<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Charges"></app-page-title>
        <form [formGroup]="chargeUploadForm">
    
            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Charge Periods</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowDataPeriod" [columnDefs]="columnDefsPeriod" [animateRows]="true"
                                [context]="context" [defaultColDef]="defaultColDef" [suppressMenuHide]="true"
                                [pagination]="true" (gridReady)="onGridReadyPeriod($event)"
                                [gridOptions]="gridOptionsPeriod" [rowSelection]="'single'">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Charge Details</div>
                    <div class="card-body">
                        <div class="col-md-12">
                            <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                                [rowData]="rowDataInfo" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                                [defaultColDef]="defaultColDef" [suppressMenuHide]="true" [pagination]="true"
                                (gridReady)="onGridReady($event)" [gridOptions]="gridOptions">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>